import { render } from "./DefaultProduct.vue?vue&type=template&id=1939a003"
import script from "./DefaultProduct.vue?vue&type=script&lang=js"
export * from "./DefaultProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__